import { render } from "./WebDevShort.vue?vue&type=template&id=88922000"
import script from "./WebDevShort.vue?vue&type=script&lang=js"
export * from "./WebDevShort.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__